<template>
	<div class="vlog-video-detail">
		<template v-if="loaded">
			<img :src="coverURL" style="display:none;"/>
			
			<div class="player-container">
				<video-player
					class="video-player vjs-big-play-centered"
					:src="videoURL"
					:poster="coverURL"
					crossorigin="anonymous"
					playsinline
					controls
					:volume="0.6"
					:fluid="true"
				/>

				<!--自动播放默认静音，暂时移除
					:autoplay="true"
					:muted="true"-->
			</div>
			<div class="video-info">
				<div class="titles">
					<h2 class="title">{{ title }}</h2>
					<p class="description">{{ description }}</p>
				</div>
				<div class="basic-info flex gap-3 items-center my-5">
					<div
						class="category text-xs inline-flex items-center font-bold  uppercase px-3 py-1 bg-gray-200 text-gray-500 rounded-full"
						v-if="category?.name?.length > 0"
						@click.prevent="showMoreCategoryContent(category.tabID)"
					>
						{{ category.name }}
					</div>
					<div class="author text-sm text-gray-500" v-if="author.length > 0">
						{{ author }}
					</div>
					<div class="source text-sm text-gray-500" v-if="source?.length > 0">
						{{ source }}
					</div>
				</div>
				<div class="play-info flex gap-3 items-center my-4">
					<div
						class="info-item play-count text-xs text-gray-600 flex gap-1 items-center"
					>
						<span class="icon">
							<svg
								width="16"
								height="16"
								viewBox="0 0 20 20"
								fill="none"
								xmlns="http://www.w3.org/2000/svg"
							>
								<path
									fill-rule="evenodd"
									clip-rule="evenodd"
									d="M4.67735 4.2798C5.98983 4.1725 7.85812 4.0625 10 4.0625C12.1421 4.0625 14.0105 4.17252 15.323 4.27983C16.2216 4.3533 16.9184 5.04049 16.9989 5.9318C17.0962 7.00837 17.1875 8.43614 17.1875 10C17.1875 11.5639 17.0962 12.9916 16.9989 14.0682C16.9184 14.9595 16.2216 15.6467 15.323 15.7202C14.0105 15.8275 12.1421 15.9375 10 15.9375C7.85812 15.9375 5.98983 15.8275 4.67735 15.7202C3.77861 15.6467 3.08174 14.9593 3.00119 14.0678C2.90388 12.9908 2.8125 11.5627 2.8125 10C2.8125 8.43727 2.90388 7.00924 3.00119 5.93221C3.08174 5.04067 3.77861 4.35327 4.67735 4.2798ZM10 2.8125C7.81674 2.8125 5.9136 2.92456 4.5755 3.03395C3.07738 3.15643 1.8921 4.31616 1.75626 5.81973C1.65651 6.92379 1.5625 8.39058 1.5625 10C1.5625 11.6094 1.65651 13.0762 1.75626 14.1803C1.8921 15.6838 3.07738 16.8436 4.5755 16.966C5.9136 17.0754 7.81674 17.1875 10 17.1875C12.1835 17.1875 14.0868 17.0754 15.4249 16.966C16.9228 16.8436 18.108 15.6841 18.2438 14.1807C18.3435 13.077 18.4375 11.6105 18.4375 10C18.4375 8.38948 18.3435 6.92296 18.2438 5.81931C18.108 4.31588 16.9228 3.15645 15.4249 3.03398C14.0868 2.92458 12.1835 2.8125 10 2.8125ZM12.1876 10.722C12.7431 10.4013 12.7431 9.59941 12.1876 9.27866L9.06133 7.47373C8.50577 7.15298 7.81133 7.55392 7.81133 8.19542V11.8053C7.81133 12.4468 8.50577 12.8477 9.06133 12.527L12.1876 10.722Z"
									fill="#9499A0"
								></path></svg></span>
						<span class="value">{{ playCount }}</span>
					</div>
					<div
						class="info-item publish-date text-xs text-gray-600 flex gap-1 items-center"
					>
						<div
							class="info-item play-count text-xs text-gray-600 flex gap-1 items-center"
						>
							<span class="icon">
								<svg
									t="1642588113899"
									class="icon"
									viewBox="0 0 1024 1024"
									version="1.1"
									xmlns="http://www.w3.org/2000/svg"
									p-id="6827"
									xmlns:xlink="http://www.w3.org/1999/xlink"
									width="16"
									height="16"
								>
									<defs></defs>
									<path
										d="M167.024 512a344.976 344.976 0 1 1 689.952 0 344.976 344.976 0 0 1-690 0zM512 106.976a405.024 405.024 0 1 0 0 810.048 405.024 405.024 0 0 0 0-810z m30 235.008a30 30 0 1 0-60 0V512c0 7.968 3.168 15.6 8.784 21.216l120 120a30 30 0 1 0 42.432-42.432L542 499.52V341.984z"
										fill="#9499A0"
										p-id="6828"
									></path>
								</svg>
							</span>
							<span class="value">{{ publishDate }}</span>
						</div>
					</div>
				</div>
			</div>
			<!-- <div class="separator"></div> -->
			<div
				class="separator"
				v-if="this.relatedVideos?.length > 0 || this.moreVideos?.length > 0"
			></div>
			<div class="related-videos section" v-if="this.relatedVideos?.length > 0">
				<h3 class="sub-title section-title">关联视频</h3>
				<vue-horizontal class="scroller" :button="false">
					<div
						v-for="item in this.relatedVideos"
						:key="item.id"
						class="related-video-item"
					>
						<VideoItem
							:videoThumbnailURL="item.file.thumbnail"
							:imageURL="item.thumbnail.thumbnail"
							:title="item.title"
							:desc="item.abstract"
							:url="'/vlog/video/' + item.id"
							:date="item.display_date"
						></VideoItem>
					</div>
				</vue-horizontal>
			</div>
			<div class="more-videos  section" v-if="this.category?.id > 0">
				<h3
					class="sub-title  section-title"
					v-if="this.moreVideos?.length > 0"
					@click.prevent="showMoreCategoryContent(category.tabID)"
				>
					更多{{ this.category.name }}视频
				</h3>
				<div class="more-videos-list">
					<ul class="list-content">
						<div class="grid grid-cols-2 gap-4 gap-y-4 ">
							<template v-for="item in this.moreVideos" :key="item.id">
								<VideoItem
									:videoThumbnailURL="item.file.thumbnail"
									:imageURL="item.thumbnail.thumbnail"
									:title="item.title"
									:desc="item.abstract"
									:url="'/vlog/video/' + item.id"
									:date="item.display_date"
								></VideoItem>
							</template>
						</div>
					</ul>
					<InfiniteLoading
						class="infinite-loader"
						@infinite="loadMoreData"
						v-if="loaded"
					>
						<template #complete>
							<div
								class="loader-indicator text-center my-3 text-xs text-gray-400"
							>
								<!-- <span>加载完成</span> -->
							</div>
						</template>
						<template #error="{ retry }">
							<div class="loader-indicator text-center my-3 text-xs">
								<button @click="retry">重试</button>
							</div>
						</template>
						<template #spinner>
							<div class="loader-indicator text-center my-3 text-xs py-1">
								<pulse-loader
									loading="loading"
									color="#cccccc"
									size="6px"
								></pulse-loader>
							</div>
						</template>
					</InfiniteLoading>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import axios from "axios";
// import mitt from "mitt";
// const emitter = mitt();

// import "vue3-video-play/dist/style.css";
// import VideoPlayer from "vue3-video-play";

import { VideoPlayer } from "@videojs-player/vue";
import "video.js/dist/video-js.css";

import VueHorizontal from "vue-horizontal";
import VideoItem from "@/components/vlog/components/VideoItem.vue";

import InfiniteLoading from "v3-infinite-loading";
import PulseLoader from "vue-spinner/src/PulseLoader.vue";

import "v3-infinite-loading/lib/style.css"; //required if you're not going to override default slots
import { useHead, useSeoMeta } from "@vueuse/head";

export default {
	setup() {
		useHead({ title: "载入视频…" });
	},
	name: "VlogVideoDetail",
	components: {
		VideoPlayer,
		VueHorizontal,
		VideoItem,
		InfiniteLoading,
		PulseLoader,
	},
	// props: ['id'],
	computed: {
		// todo ，当container小于vw时会有很大问题，暂时先用50vh。
		preferredPlayHeightValue() {
			if (this.videoAspectRatio >= 1) {
				// 扁的，返回auto
				return "auto";
			} else {
				// 高的，固定1:1
				return "50vh";
			}
		},
		shareInfo() {
			return {
				image: this.coverURL,
				description: this.description,
				title: this.title,
				url: document.location.href,
			};
		},
	},
	data() {
		return {
			id: "",
			loading: false,
			loadingError: {},
			relatedVideos: [],
			loaded: false,
			videoURL: "",
			coverURL: "",
			title: "",
			description: "",
			source: "",
			author: "",
			// category: {
			// 	name: "123",
			// 	id: 123,
			// },
			playCount: 0,
			publishDate: "",
			moreVideos: [],
			moreVideoNextPage: 1,
			videoAspectRatio: 1,
		};
	},
	methods: {
		play() {},
		updateMeta() {
			const websiteBasicInfo = this.$store.state.websiteBasicInfo;
			// console.log(websiteBasicInfo);
			var title = this.title;
			if (websiteBasicInfo) {
				if (this.title) {
					title = this.title + " - " + websiteBasicInfo.vlogDisplayTitle;
				} else {
					title = websiteBasicInfo.vlogDisplayTitle;
				}
			}

			let shareAbstract = this.description;
			let seoAbstract = this.desctiption;

			if (this.description?.trim().length == 0) {
				shareAbstract = "来自" + websiteBasicInfo.vlogDisplayTitle + "的视频内容";
				seoAbstract = shareAbstract;
			}
			else {
				seoAbstract = this.description + " - " + "来自" + websiteBasicInfo.vlogDisplayTitle + "的视频内容";
			}
			
			// console.log(shareAbstract);
			// console.log(this.description);
			
			// console.log("update meta: " + title);

			useHead({
				title: title,
				meta: [
					{
						name: "title",
						content: title,
					},
					{
						name: "description",
						content: seoAbstract,
					},
				],
			});
			useSeoMeta({
				description: shareAbstract,
				ogDescription: shareAbstract,
				ogTitle: title,
				ogImage: this.coverURL,
				twitterCard: "summary_large_image",
			});

			this.$emitter.emit("didUpdateHeadMeta", this.shareInfo);
		},
		setupContent(data) {
			// console.log(data);
			let coverURL = data.thumbnail.url;
			// console.log(coverURL);
			if (coverURL.match(/\/assets\/images\/no-image\.jpg$/g)) {
				coverURL = data.file.thumbnail;
			}

			// console.log(coverURL);

			// console.log(data.category);

			this.coverURL = coverURL;

			this.videoURL = data.file?.url;

			// console.log(this.videoURL);

			this.title = data.title;
			this.description = data.abstract;
			
			this.category = data.category;
			this.category.tabID = "c" + data.mold + "_" + data.category.id;

			// console.log(data.counter);
			this.playCount = data.counter.views - data.counter.brush_views;
			this.author = data.author;
			this.source = data.source;

			// this.author= "作者";
			// this.source= "来源";

			this.publishDate = data.published_at;
			this.loaded = true;

			var w = data.file.width;
			var h = data.file.height;
			if (w > 0 && h > 0) {
				this.videoAspectRatio = w / h;
			} else {
				this.videoAspectRatio = 1;
			}
			// console.log(this.videoAspectRatio);
			// console.log("setup");
			this.updateMeta();

			var relatedVideos = data.content
				.find(function(aContent) {
					return aContent.type == 1;
				})
				?.info?.filter(function(item) {
					return item.mold == 2;
				});
			this.relatedVideos = relatedVideos ? relatedVideos : [];
		},
		requestDetailData() {
			// request:
			// 1. category
			// console.log(this.$route.params.id);
			// console.log("requestDetailData: " + this.id);
			// 1. mark as loading
			const that = this;
			that.loading = true;

			const url = "/api/gatewayCms/articles/item/" + this.id;
			axios
				.get(url, { params: {} })
				.then((response) => {
					// that.loading = false;
					const responseData = response.data.data;
					this.setupContent(responseData);

					that.loading = false;
					that.loadingError = {};
				})
				.catch((error) => {
					that.loading = false;
					that.loadingError = error;
					// console.log(error);
				});

			// 1. request
			// 2. setup data
			// 3. data drives ui
		},
		constructMoreVideosRequestParams(page) {
			return {
				mold_types: "2",
				is_not_show_description: 1,
				page_size: 40,
				cat_ids: "" + this.category.id,
				page: page, //this.moreVideoNextPage,
				// 推荐优先、排序其次、发布时间再次
				order: '{"is_recommended":"desc","sort":"desc","published_at":"desc"}',
			};
		},
		loadMoreData(state) {
			this.requestMoreVideo(state);
		},
		requestMoreVideo(state) {
			state?.loading();
			const url = "/api/gatewayCms/articles/list";
			const that = this;
			axios
				.get(url, {
					params: this.constructMoreVideosRequestParams(this.moreVideoNextPage),
				})
				.then((response) => {
					// that.loading = false;
					const responseData = response.data;
					that.moreVideoNextPage += 1;
					if (responseData.data?.data?.length > 0) {
						that.moreVideos.push(
							...responseData.data.data.filter(function(x) {
								return x.id != that.id;
							})
						);
						state?.loaded();
					} else {
						state?.complete();
					}
				})
				.catch((error) => {
					// error;
					// that.loading = false;
					console.log(error);
					state?.error(error);
				});
		},
		refreshData() {
			// cleanup

			// request
			this.id = this.$route.params.id;
			// console.log(this.id);
			this.requestDetailData();
		},
		showMoreCategoryContent(tabID) {
			this.$router.push({ path: "/vlog/t/" + tabID });
		},
	},
	mounted() {
		this.refreshData();
		// this.id = this.$route.params.id;
		// // console.log(this.id);
		// this.requestDetailData();
	},
};
</script>
<style scoped>
.player-container {
	width: 100%;
	/* max-height: 50vw; */
}

.video-info {
	margin: 0 16px;
	margin-top: 16px;
}
.title {
	font-weight: 600;
	font-size: 18px;
	line-height: 24px;
}
.description {
	font-weight: 400;
	font-size: 15zpx;
	line-height: 22px;
	color: #777;
	margin-top: 8px;
}

.titles {
	margin-bottom: 12px;
}

.related-video-item {
	width: 30%;
	margin: 4px 8px;
}

.section-title {
	font-size: 17px;
	font-weight: bold;
	color: #555;
	margin-bottom: 8px;
}
.section {
	/* margin-top: 16px; */
	padding: 0 16px;
	margin-top: 16px;
}

.separator {
	width: auto;
	margin: 24px 16px;
	height: 1px;
	border-bottom: 0.5px #dddddd solid;
}

.info-item {
	color: #9499a0;
}

@media screen and (min-width: 500px) {
	.player-container {
		padding: 0 16px;
		margin-top: 16px;
	}
}


/* override */
.video-js .vjs-big-play-button {
    line-height: 2em;
    height: 2em;
    width: 2em;
    border: none;
    border-radius: 1em;
}

</style>
